/* global fetch */
import { clearLocalStorage } from './paypal-utils';

const cancel = (data, actions) => {
	// console.log('cancel:', data, actions);
	// Show a cancel page, or return to cart
	// Call endpoint to clear address
	clearLocalStorage();
};

module.exports = cancel;
